'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled, { css } from 'styled-components';
import Popup from '../Popup/index.js';
import { PopupContent } from '../Popup/Popup.css.js';

var TreeSelectWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: relative;\n    width: 100%;\n    ", "\n    ", "\n"], ["\n    position: relative;\n    width: 100%;\n    ", "\n    ", "\n"])), function (_a) {
    var isDisabled = _a.isDisabled;
    if (!isDisabled) {
        return '';
    }
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            pointer-events: none;\n        "], ["\n            pointer-events: none;\n        "])));
}, function (_a) {
    var cssString = _a.cssString;
    if (!cssString)
        return;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            ", "\n        "], ["\n            ", "\n        "])), cssString);
});
styled(Popup)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", " {\n        background-color: #fff;\n    }\n"], ["\n    ", " {\n        background-color: #fff;\n    }\n"])), PopupContent);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

export { TreeSelectWrapper };
//# sourceMappingURL=TreeSelect.css.js.map
